import { Component } from '@angular/core';
import { LineChartComponent } from '../../../charts/line-chart.component';

@Component({
  selector: 'app-video-content-graph',
  standalone: true,
  imports: [LineChartComponent],
  template: `
    <div class="flex items-center gap-3">
      <div class="w-[15rem] flex flex-col items-center justify-center overflow-hidden">
        <div role="tablist" class="tabs tabs-boxed">
          <a role="tab" class="tab">Video</a>
          <a role="tab" class="tab tab-active">Insights</a>
        </div>
        <h2 class="text-7xl font-bold mt-3 ">95</h2>
        <h2 class="text-sm font-bold text-zinc-500 capitalize">videos viewed</h2>
      </div>
      <div class="w-full "><app-line-chart [height]="200" [chartlabel]="false" [yAxisLabel]="false"></app-line-chart> </div>
    </div>
  `,
  styles: ``
})
export class VideoContentGraphComponent {

}
